<router-outlet></router-outlet>
<ng-http-loader [filteredUrlPatterns]="['myndbanda', 'keep-watching', 'search']"></ng-http-loader>